import { queryCache } from '@office-start/data-fetching';
import { getNewUserQueryFn } from '../helpers/getNewUserQueryFn';
import { FirstRunStorageKey, SecondRunStorageKey, TuiNewUserStorageKey, } from '../models/Constants';
import { getFirstRunState } from './getFirstRunState';
import { getSecondRunState } from './getSecondRunState';
import { getTuiNewUserState } from './getTuiNewUserState';
function fetchNewUserState(storageKey, getStateFunction) {
    var queryKey = [storageKey];
    return queryCache.fetchQuery(queryKey, getNewUserQueryFn(getStateFunction), {
        staleTime: Infinity,
        cacheTime: Infinity,
    });
}
export var fetchFirstRunState = function () {
    return fetchNewUserState(FirstRunStorageKey, getFirstRunState);
};
export var fetchSecondRunState = function () {
    return fetchNewUserState(SecondRunStorageKey, getSecondRunState);
};
export var fetchTuiNewUserState = function () {
    return fetchNewUserState(TuiNewUserStorageKey, getTuiNewUserState);
};
//# sourceMappingURL=fetchNewUserState.js.map